import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from '../styles/ourexpertteam.module.scss';
import { LazyLoadComponent } from "react-lazy-load-image-component";

interface Props {
  data?: any
}

const OurExpert: React.FC<Props> = ({ data }) => {
  const expertsettings = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  };

  return (
    <>
      <div id="expert-teams" className={styles.expertTeam}>
        <Container>
          <Row className="text-center">
            <div >
              <h2>Our Expert Team</h2>
            </div>
          </Row>
          <Row>
            <div id="batches-slider" className={styles.batchesSlider}>
              <Slider {...expertsettings} className={styles.slider}>
                {
                  data.map((team: any) => {
                    return (
                      <div className={styles.sliderCardDiv}>
                        <Card className={styles.cardCust}>
                          <LazyLoadComponent>
                            {team?.personImagePath && <Card.Img height={180} width={180} variant="top" src={team.personImagePath} alt={team?.personImageAltTag} />}
                          </LazyLoadComponent>
                          <Card.Body className={styles.cardBody}>
                            <Card.Title className={styles.subTitle}>{team?.name}</Card.Title>
                            <Card.Text className={styles.textDate} >{team?.title}, {team?.qualification}</Card.Text>
                            <Card.Text className={styles.textDate} >{team?.yearsInIndustry} Years in the industry</Card.Text>
                          </Card.Body>
                        </Card>
                      </div>
                    )
                  })
                }
              </Slider>
            </div>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default OurExpert